import { Component, inject, OnInit } from '@angular/core';
import { LangService } from 'src/app/shared/services/lang/lang.service';
import { InputDialogConfig } from '../../dialog.types';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { FormFieldService } from 'src/app/shared/form-field/services/form-field/form-field.service';
import { FormFieldComponent } from '../../../form-field/components/form-field/form-field.component';
import { FormFieldsDirective } from 'src/app/shared/form-field/directives/form-fields/form-fields.directive';
import { MatButtonModule } from '@angular/material/button';
import { FormFieldOptions } from 'src/app/shared/form-field/form-field.types';

@Component({
  selector: 'app-input',
  imports: [
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormFieldComponent,
    FormFieldsDirective,
  ],
  providers: [FormFieldService],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
})
export class InputComponent implements OnInit {
  private fb = inject(FormBuilder);
  private formFieldService = inject(FormFieldService);
  private labels = inject(LangService).lang.shared.inputDialog;
  private config: InputDialogConfig = inject(MAT_DIALOG_DATA);
  private label = this.config.label;
  private placeholder = this.config.placeholder;
  private isPassword = this.config.isPassword;
  title = this.config.title;
  subtitle = this.config.subtitle ?? '';
  okText = this.config.okText ?? this.labels.okText;
  cancelText = this.config.cancelText ?? this.labels.cancelText;

  form = this.fb.group({
    input: [''],
  });

  ngOnInit() {
    this.formFieldService.configure({
      labels: {
        input: {
          label: this.label,
          placeholder: this.placeholder,
        },
      },
      options: {
        input: FormFieldOptions.text({
          inputType: this.isPassword ? 'password' : 'text',
        }),
      },
    });
  }
}
